import { useState } from 'react';

import { AutoFields, AutoForm, SubmitField, useForm } from '@bitstopco/bitstop-theme';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

import { Button, DialogActions, DialogContent, Divider } from '@mui/material';
import toast from 'react-hot-toast';

import SCHEMAS from '@/forms/schemas';
import { useNotes } from '@/store/api/services/kyc/notes';

import { CUSTOMER_INIT_VALUES } from '@/constants/app/customers/customer';

import type { Customer, UploadDocumentModel } from '@/types';

/**
 * Customer Upload Document modal
 *
 * @param {ModalChildrenProps} { hide, props }
 * @return {*}
 */
const UploadDocument = ({ hide, props }: ModalChildrenProps) => {
  const customer = useState<Customer>(props?.customer || CUSTOMER_INIT_VALUES)[0];

  const { schema } = useForm(SCHEMAS.UPLOAD_DOCUMENT);

  const { uploadDocument } = useNotes(customer);

  const handleSubmit = async ({ file: { file }, reason }: UploadDocumentModel) => {
    try {
      await uploadDocument({ file: file as File, reason }).unwrap();

      toast.success('Note created successfully');

      hide();
    } catch {
      //
    }
  };

  return (
    <AutoForm<UploadDocumentModel> showInlineError schema={schema} onSubmit={handleSubmit}>
      <DialogContent sx={{ my: 2 }}>
        <AutoFields />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Back</Button>
        <SubmitField variant="contained">Upload documents</SubmitField>
      </DialogActions>
    </AutoForm>
  );
};

export default UploadDocument;
